export const EXCEPTION_NOTIFICATION_ARRAY = ['Service Unavailable', 'Forbidden resource', 'Forbidden'];
